import { memo } from 'react';

import { Breadcrumbs } from './Breadcrumbs';

export * from './Breadcrumbs';

export default memo(Breadcrumbs);
